<template>
  <div
    class="card report-card"
    :data-test="`${publisher.publisherInfo.name}-report-card`"
    v-if="publisher"
  >
    <div
      class="card-body d-flex flex-column p-3"
    >
      <section
        class="d-flex my-2"
      >
        <div
          :class="`col-${hasScrolls ? 6 : 7} d-flex align-items-center no-flex`"
        >
          <BaseCompanyLogo
            class="mr-3"
            :company="publisher.publisherInfo"
          />
          <p class="publisher-name">
            {{ publisher.publisherInfo.name }}
          </p>
        </div>
        <div class="flex-grow-1 d-flex align-items-center">
          <div
            class="col text-center"
            data-test="impressions"
          >
            <p
              class="font-weight-bold"
            >
              {{ toLocaleString(publisher.publisherStats.impressions) }}
            </p>
            <p>Impressions</p>
          </div>
          <div
            class="col text-center"
            data-test="clicks"
          >
            <p
              class="font-weight-bold"
            >
              {{ toLocaleString(publisher.publisherStats.clicks) }}
            </p>
            <p>Clicks</p>
          </div>
          <div
            class="col text-center"
            data-test="ctr"
          >
            <p
              class="font-weight-bold"
            >
              {{ toLocaleString(publisher.publisherStats.ctr, true) }}%
            </p>
            <p>CTR%</p>
          </div>
          <div
            v-if="hasScrolls"
            class="col text-center"
            data-test="scrolls"
          >
            <p
              class="font-weight-bold"
            >
              {{ toLocaleString(publisher.publisherStats.scrolls || 0) }}
            </p>
            <p>Scrolls</p>
          </div>
          <div
            v-if="hasScrolls"
            class="col text-center"
            data-test="str"
          >
            <p
              class="font-weight-bold"
            >
              {{ toLocaleString(publisher.publisherStats.str || 0, true) }}%
            </p>
            <p>STR%</p>
          </div>
        </div>
      </section>
      <section v-if="hasCreativeStats">
        <div
          class="d-flex mt-1 py-2 bg-light align-items-center"
          :data-test="`creative-row-${creative.creativeTemplateName}`"
          v-for="(creative, index) in publisher.publisherStats.creativeStats"
          :key="index"
        >
          <p
            :class="`col-${hasScrolls ? 6 : 7} no-flex`"
            class="text-truncate template-name"
            data-test="creative-size-name"
          >
            {{ creative.sizeName }}
          </p>
          <div class="col text-center">
            <p
              data-test="creative-impressions"
            >
              {{ toLocaleString(creative.impressions) }}
            </p>
            <p class="small text-muted">
              Impressions
            </p>
          </div>
          <div
            class="col text-center"
          >
            <p
              data-test="creative-clicks"
            >
              {{ toLocaleString(creative.clicks) }}
            </p>
            <p class="small text-muted">
              Clicks
            </p>
          </div>
          <div
            class="col text-center"
          >
            <p
              data-test="creative-ctr"
            >
              {{ getEvenRate(creative.ctr) }}
            </p>
            <p class="small text-muted">
              CTR%
            </p>
          </div>
          <div
            class="col text-center"
            v-if="hasScrolls"
          >
            <p
              data-test="creative-scrolls"
            >
              {{ isValidNumber(creative.scrolls) ? toLocaleString(getEventAmount(creative.scrolls)) : 0 }}
            </p>
            <p class="small text-muted">
              Scrolls
            </p>
          </div>
          <div
            class="col text-center"
            v-if="hasScrolls"
          >
            <p
              data-test="creative-str"
            >
              {{ getEvenRate(creative.str) }}
            </p>
            <p class="small text-muted">
              STR%
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import numbersHelper from '@/core/mixins/numbersHelper';

export default {
  name: 'PublisherReportCard',
  mixins: [numbersHelper],
  props: {
    publisher: {
      type: Object,
      required: true,
      default: () => {},
    },
    hasScrolls: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    hasCreativeStats() {
      return this.publisher.publisherStats.creativeStats.length > 0;
    },
  },
  methods: {
    getEventAmount(value) {
      return value != null ? value : '-';
    },
    getEvenRate(value) {
      return value != null ? `${this.toLocaleString(value, true)}%` : '-';
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0px;
}
.report-card {
  margin-bottom: 1.5rem;
}
.no-flex {
  flex: unset;
  min-width: unset;
}
.publisher-name {
  font-weight: bold;
  font-size: 1rem;
  flex-grow: 1;
}
.template-name {
  cursor: pointer;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.template-name:hover {
  white-space: normal;
}
</style>
